import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';

export function trackDurationOrTimeout() {
  const startTime = Date.now();

  let hasTimedOut = false;

  const timeoutId = setTimeout(() => {
    hasTimedOut = true;

    // send the analytics event after timeout
    sendAnalyticsEvent({
      action: AnalyticsAction.Track,
      payload: {
        event: AnalyticsTrackEvent.AnalysisDuration,
        properties: {
          timeout: true,
          duration: 120_000,
        },
      },
    });
  }, 120_000);

  return () => {
    if (hasTimedOut) {
      return;
    }

    clearTimeout(timeoutId);

    sendAnalyticsEvent({
      action: AnalyticsAction.Track,
      payload: {
        event: AnalyticsTrackEvent.AnalysisDuration,
        properties: {
          timeout: false,
          duration: Date.now() - startTime,
        },
      },
    });
  };
}
